<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijopleiding in stappen</h1>
      <p>
        Met een Rijopleiding in stappen (RIS) leer je stapsgewijs en met vier
        achtereenvolgende modules autorijden. Door stap voor stap de auto onder
        controle te krijgen en te werken aan je deelname in het verkeer, word je
        op veilige wijze voorbereid op het moment dat je je rijbewijs gaat
        behalen. Pas wanneer je het ene onderdeel van de Rijopleiding in stappen
        beheerst, ga je verder met de volgende stap. Na de eerste twee modules
        wordt er een toets afgenomen door je eigen rij-instructeur, terwijl de
        toets ter afsluiting van de derde module een soort generale repetitie
        ter voorbereiding op het
        <nuxt-link
          lass="whitespace-no-wrap text-primary"
          to="/informatie-over-rijscholen/praktijkexamen"
        >
          praktijkexamen
        </nuxt-link>
        is. De laatste toets is het praktijkexamen zelf bij het
        <nuxt-link
          lass="whitespace-no-wrap text-primary"
          to="/informatie-over-rijscholen/cbr"
        >
          CBR </nuxt-link
        >. Tijdens de Rijopleiding in stappen bereid je je met behulp van
        ‘huiswerk’ voor op je rijlessen.
      </p>

      <h2>De voordelen van een Rijopleiding in Stappen</h2>
      <p>Welke voordelen levert de Rijopleiding in Stappen op?</p>
      <ul>
        <li>
          Het slagingspercentage van kandidaten die een Rijopleiding in stappen
          hebben gevolgd ligt, dankzij de kwaliteit van de opleiding,
          aanzienlijk hoger dan dat van andere leerlingen.
        </li>
        <li>Je begint beter voorbereid aan je deelname in het verkeer.</li>
        <li>
          Met een Rijopleiding in stappen heb je een goed inzicht in je
          vorderingen en verbeterpunten.
        </li>
      </ul>

      <h2>Gratis informatie aanvragen?</h2>
      <p>
        Op Rijscholenvergelijker.nl heb je de mogelijkheid gratis informatie aan
        te vragen van <nuxt-link to="/"> rijscholen </nuxt-link> in je eigen
        omgeving. Het enige wat je hoeft te doen is het invullen van enkele
        gegevens en wij zorgen ervoor dat rijscholen in jouw buurt zo snel
        mogelijk contact opnemen. Het is vervolgens aan jou om je goed te laten
        informeren: hoe zit het met de uurtarieven? Waar ligt het
        slagingspercentage het hoogst? Kan ik bij de betreffende rijschool
        terecht voor een Rijopleiding in Stappen? Kies de beste rijschool zodat
        je goed voorbereid de weg op gaat en bespaar honderden euro’s op je
        rijbewijs!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Rijopleiding in stappen (RIS): Rijscholenvergelijker.nl!',
      headDescription:
        'Met de Rijopleiding in stappen, oftewel RIS, leer je stapje voor stapje autorijden. Hoe werkt het precies? Je leest het op Rijscholenvergelijker.nl!',
    }
  },
}
</script>
